import { PromptStepSchema } from '@feedyou-ai/feedbot-schema'
import { checkpointIdGenerators } from '@feedyou/utils'

import { GetSubdialogConnectionsMetadata } from '../../../types'

export const getSubdialogConnectionsMetadata: GetSubdialogConnectionsMetadata<PromptStepSchema> = (
  step,
  parentDialogId
) => {
  if (!step.validator || !step.validator.type) {
    return []
  }

  return [
    {
      checkpointLink: checkpointIdGenerators.validatorCase(step.id, 'valid'),
      parentDialog: parentDialogId,
      childDialog: step.validator.validDialog
    },
    {
      checkpointLink: checkpointIdGenerators.validatorCase(step.id, 'invalid'),
      parentDialog: parentDialogId,
      childDialog: step.validator.invalidDialog
    },
    {
      checkpointLink: checkpointIdGenerators.answer(step.id, 'default'),
      parentDialog: parentDialogId,
      childDialog: step.validator.invalidDialog
    },
    ...(step.answers ?? [])
      .filter(answer => answer.dialog)
      .map(answer => ({
        parentDialog: parentDialogId,
        childDialog: answer.dialog,
        checkpointLink: checkpointIdGenerators.answer(step.id, answer.id)
      }))
  ]
}
